{
  "rest400": "Valideringsfeil",
  "image.delete": "Kunne ikkje slette biletet. Prøv igjen.",
  "attachmentFilesLoadFailed": "Kunne ikkje hente alle vedlegga.",
  "accountSettings.contactInformation.updateError": "Kunne ikkje lagre kontaktinformasjon. Vennlegst prøv igjen.",
  "associate.delete": "Kunne ikkje slette samarbeidspartner. Vennlegst prøv igjen.",
  "associate.edit": "Kunne ikkje redigere samarbeidspartnere. Vennlegst prøv igjen.",
  "brreg.notFound": "Ikkje funne i Brønnøysundsregistrene.",
  "clusterAdvisor.create": "Kunne ikkje legge til som rådgjevar. Vennlegst prøv igjen.",
  "clusterAdvisor.remove": "Kunne ikkje fjerne rådgjevarar. Vennlegst prøv igjen.",
  "clusterBoardMember.create": "Kunne ikkje legge til styremedlem. Vennlegst prøv igjen.",
  "clusterBoardMember.remove": "Kunne ikkje fjerne kontakter frå styringsgruppa. Vennlegst prøv igjen.",
  "clusterManagement.create": "Kunne ikkje legge til klyngeleiing. Vennlegst prøv igjen.",
  "clusterMissingManager": "Klynga manglar klyngeleiar",
  "clusterVisionMision.update": "Kunne ikkje opppdatere klyngens visjon og misjon. Vennlegast prøv igjen.",
  "company.infoNotFound": "Kunne ikke finne informasjon om bedriften. Vennligst prøv igjen.",
  "companyCreate": "Kunne ikkje opprette ny bedrift. Vennlegst prøv igjen.",
  "companyInformation.update": "Kunne ikkje oppdatere selskapsinformasjon. Vennlegst prøv igjen.",
  "companyUpdate": "Kunne ikkje oppdatere bedrift. Vennlegst prøv igjen.",
  "contact.add.interestArea": "Kunne ikkje oppdatere interesseområder for kontakt.",
  "contact.couldNotCreate": "Kunne ikke opprette kontakt. Vennligst prøv igjen.",
  "contact.edit": "Kunne ikkje oppdatere kontakt. Vennlegst prøv igjen.",
  "contact.remove.interestArea": "Kunne ikkje fjerne interesseområder for kontakt.",
  "contact.update.information": "Kunne ikkje oppdatere kontaktinformasjon.",
  "contacts.delete": "Kunne ikkje slette kontaktene. Vennlegst prøv igjen.",
  "contacts.edit": "Kunne ikkje redigere kontaktene. Vennlegst prøv igjen.",
  "couldNotCreateGeneric": "Kunne ikke opprette {{ value }}. Vennligst prøv igjen.",
  "email.alreadyInUseInList": "Denne e-posten er allerede satt til en annen kontakt i dette skjemaet.",
  "entityNotFound": "{{ entityName }} ikkje funne.",
  "error.EditEventWithTimeEntries": "Dato kan ikkje redigerast dersom eigeninnsats har blitt registrert på eventet.",
  "errorButSaved": "Det har skjedd ein feil men dataen har blitt lagra.",
  "error.FetchingData": "Det oppstod ein feil under henting av data. Vennlegst prøv igjen.",
  "errorCode.BothReqularAndCustom": "Både standard finansieringskilde og egendefinert kan ikkje brukes samtidig",
  "errorCode.EndDateBeforeStartDate": "Sluttdato kan ikkje vere før startdato",
  "errorCode.FileTypeNotSupported": "Filtypen er ikkje støtta",
  "errorCode.GreaterThanOrEqualToZero": "{{fieldName}} må vere større eller lik 1",
  "errorCode.GreaterThanZero": "{{fieldName}} må vere større enn 0",
  "errorCode.InvalidOrganizationNumber": "Ugyldig organisasjonsnummer",
  "errorCode.MissingFinanceSource": "Finansieringskilde og egendefinert navn kan ikkje begge vere tomme",
  "errorCode.NotFound": "{{fieldName}} blei ikkje funne.",
  "errorCode.Required": "{{fieldName}} må fylles ut",
  "excel.import.error": "Noe gikk galt under importering av Excel-filen. Kan være forskjell på ditt Excel-skjema og mal. Last ned mal og prøv igjen.",
  "excel.validation.title": "Feil som blei oppdaga i Excel-skjema",
  "fieldCannotBeBlank": "Feltet kan ikkje være blankt.",
  "focusArea.create": "Kunne ikkje opprette fokusområde. Vennlegast prøv igjen.",
  "focusArea.update": "Kunne ikkje oppdatere fokusområdet. Vennlegst prøv igjen.",
  "leads.delete": "Kunne ikkje slette leads. Vennlegst prøv igjen.",
  "leads.edit": "Kunne ikkje redigere leads. Vennlegst prøv igjen.",
  "leadsNotApproved": "Kunne ikkje godkjenne leads til medlemmar. Prøv igjen.",
  "least1RowForAction": "Du må velge minst ei rad for å gjere denne handlinga.",
  "mainGoal.create": "Kunne ikkje opprette hovudmål. Vennlegast prøv igjen.",
  "mainGoal.update": "Kunne ikkje oppdater hovudmål. Vennlegst prøv igjen.",
  "member.addContacts": "Kunne ikkje legge til alle kontaktene. Vennlegst prøv igjen.",
  "member.couldNotCreate": "Kunne ikke opprette medlem. Vennligst prøv igjen.",
  "member.create.plural": "Noe gikk galt under opprettelsen av medlemmene. Vennligst prøv igjen.",
  "member.massDelete": "Kunne ikkje slette alle medlemmar. Vennlegst prøv igjen.",
  "member.massUpdate": "Kunne ikkje redigere alle medlemmane. Vennlegst prøv igjen.",
  "member.removeContacts": "Kunne ikkje fjerne alle kontaktene frå medlem. Vennlegst prøv igjen.",
  "member.removeInterestArea": "Kunne ikkje fjerne interesseområder frå medlem. Vennlegst prøv igjen.",
  "member.update": "Kunne ikkje oppdatere medlem. Vennlegst prøv igjen.",
  "member.update.mainContact": "Kunne ikkje oppdatere hovedkontakt for medlem. Vennlegst prøv igjen.",
  "member.updateInterestArea": "Kunne ikkje oppdatere interesseområder for medlem. Vennlegst prøv igjen.",
  "memberFee.create": "Kunne ikke opprette medlemskontingen. Vennlegast prøv igjen.",
  "memberFee.delete": "Kunne ikke slette medlemskontingent. Vennlegast prøv igjen.",
  "memberFee.update": "Kunne ikke oppdatere medlemskontingent. Vennlegast prøv igjen.",
  "noClusterChosen": "Inga klynge vald. Vennlegst velg klynge før denne handlinga kan utførast.",
  "noClusterMemberId": "Ingen medlems-id funne. Prøv å gå til sida på nytt.",
  "noFileSelected": "Fann ikkje fil. Prøv å velg på nytt.",
  "onewayinLeadNoCreateDto": "Kunne ikkje opprette Lead. Prøv å lukke og åpne boksa på nytt.",
  "only1RowToChangeRole": "Du kan kun endre rolle for ein person om gangen.",
  "organizationNumber.alreadyInUse": "Organisasjonsnummer allerede i bruk.",
  "portalInvitation.send": "Kunne ikke sende portalinvitasjoner. Vennlegast prøv igjen.",
  "postCode.notFound": "Poststed ikke funnet for dette postnummeret.",
  "projectCategory.create": "Kunne ikke opprette ny prosjektkategori. Sjekk at samme navn ikke allerede eksisterer og prøv på nytt.",
  "requiresOneFile": "Må ha mist ei fil som vedlegg",
  "rest401": "Ikkje autentisert",
  "rest403": "Ikkje autorisert",
  "rest404": "Kunne ikke finne {{ entityName }}",
  "rest409": "Di endring kan ha komt i konflikt med andre sine endringer, prøv på nytt.",
  "rest500": "Det har skjedd ein kritisk feil.",
  "roles.update": "Kunne ikke oppdatere rolle for {{ name }}. Vennlegast prøv igjen.",
  "selfEffort.couldNotImport": "Kunne ikkje laste opp eigeninnsats. Sjekk at reknearket følger malen.",
  "selfEffort.couldNotRegister": "Kunne ikkje redigere eigeninnsats. Sjekk at reknearket følger malen.",
  "selfEffort.newContactInvalidEmail": "Kunne ikkje opprette ny kontakt med ugyldig epost {{ email }}.",
  "selfEffort.newContactNoEmail": "Kunne ikkje opprette ny kontakt med tom epost {{ email }}.",
  "selfEffort.newContactsCreateError": "Kunne ikkje opprette kontakter. Dobbeltsjekk at du følger reknearkmalen og prøv igjen.",
  "selfEffort.newMemberCouldnotCreate": "Kunne ikkje opprette medlem med organisasjonsnummer {{ orgNumber }}.",
  "selfEffort.newMemberCouldNotSave": "Kunne ikkje lagre og hente nyaste medlem ({{ member }}')",
  "selfEffortNotApproved": "Kunne ikkje godkjenne eigeinnsats. Prøv igjen.",
  "somethingWentWrongTryAgain": "Noko gjekk gale. Prøv igjen.",
  "undefinedProperty": "\"{{ property }}\" kan ikkje være udefinert.",
  "unretire.contact": "Kunne ikke melde inn kontakt. Vennlegast prøv igjen.",
  "unretire.member": "Kunne ikke melde inn medlem. Vennlegast prøv igjen.",
  "user.UserHasMultipleClusters": "Brukaren har fleire klynger, klynge-ID må settast",
  "validation.email": "Ikke gyldig e-post adresse.",
  "validation.maxValue": "Verdien kan ikke være større enn {{ value }}",
  "validation.minValue": "Verdien kan ikke være mindre enn {{value }}",
  "validation.missingFileName": "manglar filnamn",
  "validation.organizationNumber": "Ikke gyldig organisasjonsnummer.",
  "validation.postalCode": "Ikke gyldig postnummer.",
  "validation.required": "Dette feltet er påkrevd.",
  "validation.uniqueEmailInClusterContacts": "Denne e-posten er allerede i bruk av en annen kontakt i denne klyngen.",
  "wrongFileFormat": "Feil filformat.",
  "notFound.title": "Oisann, her var det ingenting",
  "notFound.subtitle1": "Sida du prøvde å gå til vart ikkje funne",
  "notFound.subtitle2": "Det kan hende det du leitar etter ikkje lenger eksisterer, eller du har logga deg inn under ein annan aktør. Sjekk gjerne om du har logga deg inn under rett aktør.",
  "noClusterUserId": "Ingen brukarId blei funne, prøv igjen.",
  "malwareDetected": "Fila inneheld potensielt skadeleg innhald og er derfor blokkert. Du kan prøve å laste opp ei anna fil."
}
